// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"HoursSelector_pattern-gradient__TdNCh","grid":"HoursSelector_grid__QJMef","title":"HoursSelector_title__iggYq"};